import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { t } from '@moovly/i18n';

import Page from '../../../components/Page';
import AddUserButtonContainer from '../containers/AddUserButtonContainer';
import UsersContainer from '../containers/UsersContainer';
import usersSlice from '../store/users.store';
import DownloadUsersCsv from '../containers/DownloadUsersCsv';
import _ from 'lodash';
import { LocalStorageService } from '@moovly/clients';

const UsersPage: React.FC = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const search = React.useMemo(() => searchParams.get('search'), [searchParams]);
  // FIXME useSettingUpdate not working for backoffice settings
  const canAddUsers = _.get(
    JSON.parse(LocalStorageService.getItem('moovly.groupSettings') || '{}'),
    'backoffice.add_users',
    false
  );

  React.useEffect(() => {
    dispatch(usersSlice.actions.setSearch(search && search.length ? search : null));
  }, [search, dispatch]);

  return (
    <Page
      header="users"
      title={t('menu.users')}
      actions={
        <>
          <DownloadUsersCsv />
          {canAddUsers && <AddUserButtonContainer />}
        </>
      }
    >
      <UsersContainer />
    </Page>
  );
};

export default UsersPage;
